<template>
  <div v-show="showPicker" class="github-filepicker">
    <click-outside :handler="close" id="github-filepicker-co" class="fp-popup" style="width: 80%; max-height: 91%">
      <FilePickerHeader :logo="logo" title="GitHub" connector="github" :domain="undefined" :key="'github'" :user="user"
                        @close-filepicker="cancel"/>
      <div class="filepicker-selector-container">
        <div style="display: inline-flex; width: 100%;" v-if="orgs.length">
          <div class="filepicker-input-item">
            <div class="bold">Select Organization</div>
            <v-select :options="orgs" v-model="selectedOrg"
                      class="v-select-styling"
                      label="name"
                      @input="org_selected"></v-select>
          </div>
          <div id="repo-selector-container" class="filepicker-input-item">
            <div class="bold">Select Repository</div>
            <v-select :options="repos" v-model="selectedRepo"
                      class="v-select-styling"
                      @input="repo_selected"></v-select>
          </div>
          <div id="branch-selector-container" class="filepicker-input-item">
            <div class="bold">Select Branch</div>
            <v-select :options="branches" v-model="selectedBranch" label="name"
                      @input="branch_selected"></v-select>
          </div>

        </div>
        <div v-else>
          No orgs found...
        </div>
      </div>
      <div class="picker-subheader">
        <div class="picker-subheader-text flex">
          <div style="padding-left: 9px;" class="picker-subheader-text">Select Files</div>
        </div>
        <div class="picker-subheader-selected-text">
          <div>Selected Files <span v-if="fileCount > 0">&nbsp;({{ fileCount }})</span></div>
        </div>
      </div>
      <div class="filepicker-body">
        <div class="file-tree" style="padding: 18px 24px 0 !important;">
          <tree-node
              class="item"
              :item="branchFileTree"
          ></tree-node>
        </div>
        <div class="selected-files">
          <div class="file-picker-tree">
            <div class="selected-file" style="list-style: none" v-for="(file, k) in files">
              <div>{{ k }} (<span>{{ file.size }}</span> bytes)</div>
              <div @click="deselectFile($event, file, k)" style="cursor: pointer">
                &nbsp; x
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="picker-footer-links" v-if="fileCount > 0">
        <div class="picker-subheader-text flex">
        </div>
        <div class="picker-footer-links-selected-text">
          <div class="picker-footer-link">
            <a
                class="picker-footer-link"
                v-if="fileCount > 0"
                title="Select all"
                @click="deselectAllFiles">
              Clear Files
            </a>
          </div>
        </div>
      </div>
      <div class="filepicker-footer">
        <button class="cancel-btn" @click.prevent="cancel">Cancel</button>
        <button :class="submitButtonClass" id="github-upload-files" @click.prevent="upload">Upload</button>
      </div>
    </click-outside>
    <div class="fp-mask" :style="{ display: showPicker ? 'block' : 'none' }"></div>
  </div>
</template>

<script>

import '../style.scss';
import axios from 'axios';
import TreeNode from './TreeNode';
import ClickOutside from 'onclick-outside';
import {EventBus} from '../../../../event-bus';
import {isEmpty} from 'lodash';
import "vue-select/dist/vue-select.css";
import FilePickerHeader from "../FilePickerHeader";
import {mapGetters, mapState} from "vuex";
let $token = $("#token");

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

if ($token.length) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = $token.attr('content');
}
else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
export default {
  //todo break into components
  data () {
    return {

      errored: false,

      showPicker: false,
      fileType: undefined,
      orderId: undefined,

      //options
      orgs: [],
      repos: [],
      branches: [],

      //users
      user: undefined,

      //selected files
      files: {},
      fileCount: 0,
      branchFileTree: {},

      //selections
      selectedOrg: undefined,
      selectedRepo: undefined,
      selectedBranch: undefined,
    };
  },
  components: {
    TreeNode: TreeNode,
    FilePickerHeader,
    'click-outside': ClickOutside
  },
  props: [
    'logo'
  ],
  watch: {
    errored: function (val, oldVal) {
      if (val) {
        popupAlert("Oops! Something went wrong...", "Error", () => {
          this.clearAllTheThings();
        });
      }
    },
    showPicker: function (val, oldVal) {
      if (val) {
        //instantiate user's repositories
        axios.get(`/connectors/github/picker/`)
            .then(response => {
              this.orgs = response.data.orgs;
              this.user = response.data.username;
            }).catch(function (error) {
          console.log(error);
        });
      }
    }
  },
  computed: {
    ...mapState({
      uploadFileType: state => state.CreateOrderStore.orderDetails.uploadFileType,
      features: state => state.store.features,
    }),
    ...mapGetters('FeatureFlagStore', {
      'getFeature': 'getFeatureStatusByName'
    }),
    submitButtonClass: function () {
      return {
        'disabled-btn': Object.keys(this.files).length === 0,
        'bbutton': Object.keys(this.files).length > 0
      };
    },
  },
  methods: {
    org_selected: function () {

      if (!this.selectedOrg) return;

      axios.post('/connectors/github/picker/reposForOrg', {
        orgName: this.selectedOrg.name
      }).then((response) => {
        this.repos = response.data;
        this.selectedBranch = undefined;
        this.selectedRepo = undefined;
        this.branchFileTree = {};
      })
          .catch((error) => {
            this.errored = true;
          });

    },
    repo_selected: function () {

      if (!this.selectedRepo) return;

      axios.get(`/connectors/github/picker/branchesForRepo/${this.selectedOrg.name}/${this.selectedRepo}`)
          .then(response => {
            this.branches = response.data;
            this.selectedBranch = undefined;
            this.branchFileTree = {};
          }).catch((error) => {
        this.errored = true;
      });

    },
    branch_selected: function () {

      if (!this.selectedBranch) return;

      axios.get(`/connectors/github/picker/org/${this.selectedOrg.name}/repo/${this.selectedRepo}/tree/${this.selectedBranch.name}`)
          .then(response => {
            this.branchFileTree = response.data;
          }).catch((error) => {
        this.errored = true;
      });

    },

    //close function
    close () {
      if (!this.showPicker) return;

      this.clearAllTheThings();
      this.showPicker = false;

    },

    //cancel button
    cancel () {
      this.clearAllTheThings();
      this.showPicker = false;
    },

    //upload button
    upload (e) {
      e.preventDefault();

      let fileType = this.uploadFileType;
      let orderId = this.orderId;

      if (!this.orderId) {
        orderId = $("#order_id").val() === undefined ? 0 : $("#order_id").val();
      }

      if (isEmpty(this.files)) alert('No files selected...');

      axios.post('/connectors/github/picker/upload', {
        files: this.files,
        org: this.selectedOrg.name,
        repo: this.selectedRepo,
        branch: this.selectedBranch,
        orderId: orderId,
        fileType: fileType

      }).then(() => {

        //update file upload box
        let orderId = getCurrentOrderId(); // TODO

        EventBus.$emit('file-uploaded');

        //let any listeners know about the new file
        EventBus.$emit('file-uploaded');

        this.clearAllTheThings();
        this.close();

      }).catch((error) => {

        this.errored = true;

      });

    },

    deselectFile (e, file, key) {
      e.preventDefault();
      this.fileCount -= 1;
      this.$delete(this.files, key);
    },

    deselectAllFiles () {
      this.files = {};
      this.fileCount = 0;
    },

    //initiate shutdown sequence
    clearAllTheThings () {
      this.deselectAllFiles();
      this.selectedOrg = undefined;
      this.selectedBranch = undefined;
      this.selectedRepo = undefined;
      this.branchFileTree = {};
      this.repos = [];
      this.branches = [];
      this.errored = false;
    },

  },
  mounted () {

    //catch github filepicker open
    EventBus.$on("show-github-picker", (data) => {
      this.showPicker = true;
      this.fileType = data.type;
      this.orderId = data.orderId;
    });

    //catch when files are added, add them to this.files
    EventBus.$on('file-picked', ({name, meta}) => {
      if (!(name in this.files)) {
        this.$set(this.files, name, meta[0]);
        this.fileCount += 1;
      }
    });
  }
};
</script>
